import initializeGroupDefaults from './initializeGroupDefaults';
import GroupsState from '../schema/GroupsState';
import GroupInformation from '../schema/GroupInformation';
import { action } from 'satcheljs/lib/legacy';

const addOrUpdateGroup = action('addOrUpdateGroup')(
    (state: GroupsState, groupSmtp: string, groupInformation: GroupInformation) => {
        groupSmtp = groupSmtp.toLowerCase();
        groupInformation = initializeGroupDefaults(state, groupSmtp, groupInformation);

        if (state.groups.has(groupSmtp)) {
            const currentGroup: GroupInformation = state.groups.get(groupSmtp);
            if (groupInformation.basicInformation) {
                currentGroup.basicInformation = groupInformation.basicInformation;
            }
            if (groupInformation.groupDetails) {
                // Try to preserve MailboxSettings (obtained only on full group details)
                // when updating group details and it wasn't returned (Basic Details calls)
                if (
                    currentGroup.groupDetails &&
                    currentGroup.groupDetails.MailboxSettings &&
                    !groupInformation.groupDetails.MailboxSettings
                ) {
                    groupInformation.groupDetails.MailboxSettings =
                        currentGroup.groupDetails.MailboxSettings;
                }

                currentGroup.groupDetails = groupInformation.groupDetails;
            }
            if (groupInformation.members) {
                currentGroup.members = groupInformation.members;
            }
            if (groupInformation.groupDetailsError != null) {
                currentGroup.groupDetailsError = groupInformation.groupDetailsError;
            }
        } else {
            state.groups.set(groupSmtp, groupInformation);
        }
    }
);

export default addOrUpdateGroup;
